import React, { useState, useEffect, useRef } from "react";
import LogNav from "../layout/LoggedNav";
import Table from "../IncidentsLog/Table";
import UserDetailTable from "../IncidentsLog/UserDetailTable";
import {
  getIncidentsByCoursesId,
  getUserCourses,
} from "../../services/apiService";
import ENUMS from "../../utils/ENUMS";
import { getAuthData } from "../../services/authService";

const auth = getAuthData();

const IncidentsLog = () => {
  const token = localStorage.getItem(ENUMS.AUTH);

  const [courses, setCourses] = useState([]);
  const [incidents, setIncidents] = useState([]);

  const [selectedCourse, setSelectedCourse] = useState();
  const [loading, setLoading] = useState(true);
  const [searchKey, setSearchKey] = useState("");

  const incidentRef = useRef();

  const getCourses = () => {
    getUserCourses(token).then((data) => {
      // console.log("get courses",data)
      if (data && data.data?.status === "SUCCESS") {
        setCourses(data.data.data);
        setSelectedCourse(data.data.data[0]?.id);
        setLoading(false);
      } else {
        setLoading(false);
      }
    });
  };

  const getIncidents = (courseId, searchKey) => {
    getIncidentsByCoursesId(token, courseId, searchKey).then((data) => {
      if (data && data.data?.status === "SUCCESS") {
        setIncidents(data.data.data);
        // console.log(data.data.data)
      } else {
        setLoading(false);
      }
    });
  };

  useEffect(() => {
    getCourses();
  }, []);

  useEffect(() => {
    if (selectedCourse) {
      getIncidents(selectedCourse, searchKey);
    }
  }, [selectedCourse, searchKey]);

  return (
    <>
      <section className="club_Login">
        <div className="page-width">
          <div className="c-live-block gap-block-section">
            <h1 className="c-live--title text-jost-sb-50">
            </h1>
            {/* <LogNav /> */}
            <div ref={incidentRef} className="c-live__wrap incidentslog">
              <div>
                <Table
                  incidents={incidents}
                  searchKey={searchKey}
                  setSearchKey={setSearchKey}
                  selectedCourse={selectedCourse}
                  courses={courses}
                  setSelectedCourse={setSelectedCourse}
                />
              </div>
              <UserDetailTable
                incidentRef={incidentRef}
                selectedCourse={selectedCourse}
                getIncidents={getIncidents}
                incidents={incidents}
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default IncidentsLog;
